<template>
  <header class="bg-purple-ap-100 p-4 shadow-lg">
    <nav class="flex max-w-4xl m-auto justify-between items-center">
      <div>
        <button @click.prevent="toggleMenu()" class="toggle-menu">
          <i
            v-if="!isSideDrawerOpen"
            class="material-icons text-white text-4xl align-middle"
            >menu</i
          >
          <i v-else class="material-icons text-white text-4xl align-middle"
            >close</i
          >
        </button>
      </div>
      <div class="flex items-center justify-center">
        <img
          class="mr-5"
          width="50"
          src="../../../assets/img/logo.png"
          alt="CHI"
        />
        <router-link
          tag="p"
          class="brand text-white text-3xl font-bold cursor-pointer"
          to="/"
        >
          CHI Au Pair</router-link
        >
      </div>
    </nav>
    <div id="side-menu" :class="[isSideDrawerOpen ? 'opened' : 'closed']">
      <div class="wrapper">
        <button class="close-menu" @click.prevent="toggleMenu()">
          <i class="material-icons">close</i>
        </button>

        <ul v-if="applicationLevel != 5">
          <li class="list-header">Au Pairs</li>
          <li>
            <router-link :to="{ name: 'AvailableAuPairs' }"
              >Available Au Pairs</router-link
            >
          </li>
          <li v-if="applicationLevel >= 2 && applicationLevel != 5">
            <router-link :to="{ name: 'FavoriteAuPairs' }">
              Your Favorites
              <span
                v-if="this.$store.state.user.favoriteAuPairs.length"
                class="float-right text-white text-center font-medium px-2 text-sm bg-purple-ap-100 rounded"
                >{{ this.$store.state.user.favoriteAuPairs.length }}</span
              >
            </router-link>
          </li>
          <li v-if="applicationLevel >= 3 && applicationLevel != 5">
            <router-link :to="{ name: 'RequestInterview' }">
              Your Interview Requests
              <span
                v-if="this.$store.state.user.requestInterview.length"
                class="float-right text-white text-center font-medium px-2 text-sm bg-purple-ap-100 rounded"
                >{{ this.$store.state.user.requestInterview.length }}</span
              >
            </router-link>
          </li>
          <li v-if="applicationLevel >= 4 && applicationLevel != 5">
            <router-link :to="{ name: 'Matches' }">Au Pair Request</router-link>
          </li>
        </ul>
        <ul>
          <li class="list-header">Your Account</li>
          <li>
            <router-link to="/">Dashboard</router-link>
          </li>
          <li>
            <router-link to="/user-profile">Account Information</router-link>
          </li>
          <li>
            <a class="cursor-pointer" @click="logOut">Log Out</a>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="isSideDrawerOpen" class="overlay" @click="closeOverlay"></div>
  </header>
</template>

<script>
export default {
  name: "TheHeader",
  props: ["isSideDrawerOpen", "applicationLevel"],

  methods: {
    toggleMenu() {
      this.$emit("toggleMenu");
    },
    logOut() {
      this.$emit("logout");
    },
    closeOverlay() {
      this.$emit("toggleMenu");
    },
  },
};
</script>

<style scoped>
.overlay {
  background: rgba(0, 0, 0, 0.7);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9998;
  transition: all 0.3s;
}

p.brand {
  @apply font-sil;
  @apply text-white;
  transition: all 0.3s;
}

#side-menu {
  position: fixed;
  left: 0;
  top: 0;
  width: 0;
  background: #fff;
  height: 100%;
  z-index: 9999;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.2);
  overflow-x: hidden;
  transition: width 0.3s, opacity 0.6s;
}

.wrapper {
  position: relative;
  padding: 30px 0;
}

#side-menu.opened {
  width: 350px;
  opacity: 1;
}

#side-menu.closed {
  width: 0;
  opacity: 0;
  transition: width 0.3s, opacity 0.1s;
}

.close-menu {
  position: absolute;
  top: 10px;
  right: 10px;
}

.close-menu i {
  font-size: 3rem;
  opacity: 0.7;
}

#side-menu li {
  padding: 10px 15px;
  border-bottom: 1px solid #00000010;
}

#side-menu li:last-child {
  border-bottom: none;
}

#side-menu li a {
  color: #555;
}

#side-menu li.list-header {
  padding: 10px 15px;
  @apply text-purple-ap-100;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.9rem;
  border: none;
  margin-top: 20px;
}

#side-menu li a.router-link-exact-active {
  @apply text-purple-ap-100;
}

.toggle-menu {
  cursor: pointer;
}

.toggle-menu:hover {
  cursor: pointer;
}
</style>
